import React from 'react'
import { HubPublicAdministrationManagement } from 'domain/feature/hub/public-administration'

export const HubPublicAdministrationPage = (): JSX.Element => {
  return (
    <HubPublicAdministrationManagement />
  )
}